import { RoutePaths } from '@/routes'
import { Navigate } from 'react-router'

export default function Page() {
  return <Navigate to={RoutePaths.login} />
}
